<template>
  <v-row
    align="center"
    justify="center"
  >
    <v-overlay
      :absolute="true"
      :dark="false"
      z-index="9999"
    >
      <v-card width="350" class="rounded-lg">
        <v-card-title>
          Create Layer
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="item.map_name"
            label="Enter map name"
            disabled
            hide-details
          />
          <v-select
            v-model="item.category_id"
            :items="categories"
            label="Enter runtime category"
            item-text="title"
            item-value="id"
            v-validate="{
              required: true
            }"
            :error-messages="errors.collect('runtime category')"
            data-vv-name="runtime category"
          />
          <v-checkbox
            v-model="item.rotation"
            label="rotation"
            dense
          />
          <v-color-picker
            v-model="item.color"
            class="elevation-0"
            hide-mode-switch
            hide-inputs
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="blue darken-1" dark text @click="cancel">Cancel</v-btn>
          <v-btn color="blue darken-1" dark @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-overlay>
  </v-row>
</template>

<script>
import L from 'leaflet'
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      categories: []
    }
  },
  async created () {
    const { data } = await this.$axios.get(this.$store.getters.projectPath + '/runtime-categories/map', {
      params: {
        columns: ['title', 'id']
      }
    })
    .catch(error => ({ data: { err: true, message: error.response.data } }))

    if (data.err) {
      this.$toasted.error(data.message)
    } else {
      this.categories = data
    }
  },
  mounted () {
    L.DomEvent.disableClickPropagation(this.$el)
    L.DomEvent.disableScrollPropagation(this.$el)
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    save () {
      this.$validator.validateAll().then(async res => {
        if (res) {
          const { data } = await this.$axios.post(
            this.$store.getters.projectPath + '/runtime-layers/' + this.item.map_name,
            this.item
          ).catch(error => ({ data: { err: true, message: error.response.data } }))

          if (data.err) {
            this.$toasted.error(data.message)
          } else {
            this.$toasted.success('Layer created')
            this.$emit('create', data)
            this.$emit('close')
          }
        }
      })
    }
  }
}
</script>
